import type { AllRouteEndpoints } from "../routeTypes";
export const companiesCompanyIdNotificationPreferencesUpdateCacheKeys: AllRouteEndpoints[] = [];
